export const ReportDataFor = {
  all: { value: "All", name: "Wszystko" },
  roovee: { value: "Roovee", name: "Roovee" },
  operator: { value: "Operator", name: "Zamawiający" }
}
